import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import CookieBanner from '../../components/feature/CookieBanner';

const ServicesPage = () => {
  useEffect(() => {
    document.title = 'Hizmetlerimiz - İzmir Vize Danışmanlığı | LH Global Pass';
    window.scrollTo(0, 0);
  }, []);

  const services = [
    {
      icon: 'ri-plane-line',
      title: 'Schengen Bölgesi C Tipi Vizeler',
      subtitle: 'Ticari, Turistik, Aile ve Arkadaş Ziyareti',
      description: 'Kısa süreli seyahatler için Schengen C tipi vizelerde başvuru dosyası hazırlığı, randevu dağıtımı ve evrak kontrol desteği sunuyoruz. Almanya, Fransa, İtalya, İspanya, Hollanda ve diğer Schengen ülkeleri için profesyonel danışmanlık hizmeti veriyoruz.',
      features: ['Evrak hazırlığı ve kontrol', 'Randevu alma desteği', 'Başvuru takibi', 'Mülakat hazırlığı'],
    },
    {
      icon: 'ri-graduation-cap-line',
      title: 'Schengen Bölgesi D Tipi Vizeler',
      subtitle: 'Çalışma, Eğitim',
      description: 'Uzun süreli oturum veya eğitim amaçlı vizelerde resmi kurumlara uyumlu prosedür yönetimi sağlıyoruz. Üniversite kabul belgesi, iş sözleşmesi ve diğer gerekli evrakların hazırlanmasında tam destek veriyoruz.',
      features: ['Uzun süreli vize danışmanlığı', 'Evrak tercüme desteği', 'Apostil işlemleri', 'Sigorta düzenleme'],
    },
    {
      icon: 'ri-flag-line',
      title: 'Amerika Vizesi',
      subtitle: 'Turistik',
      description: 'DS-160 form hazırlığı, randevu görüşmeleri ve mülakat danışmanlığı ile Amerika vize sürecinizi kolaylaştırıyoruz. SEVIS ücreti ödemesi, konsolosluk randevusu ve mülakat hazırlığı konusunda deneyimli ekibimizle yanınızdayız.',
      features: ['DS-160 form doldurma', 'Mülakat simülasyonu', 'Evrak hazırlığı', 'Randevu takibi'],
    },
    {
      icon: 'ri-shield-star-line',
      title: 'İngiltere Vizesi',
      subtitle: 'Turistik',
      description: 'Evrak hazırlığı, dilekçe desteği ve başvuru merkezi yönlendirmesi ile İngiltere vize başvurunuzu yönetiyoruz. Online başvuru formu, biyometrik randevu ve evrak kontrolü süreçlerinde profesyonel destek sağlıyoruz.',
      features: ['Online form doldurma', 'Biyometrik randevu', 'Evrak kontrolü', 'Dilekçe hazırlama'],
    },
    {
      icon: 'ri-file-text-line',
      title: 'Oturum Kartı Başvuruları',
      subtitle: 'AB Ülkeleri',
      description: 'AB ülkeleri başta olmak üzere oturum kartı yenileme ve ilk başvuru danışmanlığı hizmetleri sunuyoruz. Geçici oturum, daimi oturum ve çalışma izni başvurularında tüm süreçleri yönetiyoruz.',
      features: ['İlk başvuru danışmanlığı', 'Yenileme işlemleri', 'Evrak tercümesi', 'Takip hizmeti'],
    },
    {
      icon: 'ri-team-line',
      title: 'Göçmenlik ve Aile Birleşimi Süreçleri',
      subtitle: 'Tüm Ülkeler',
      description: 'Aile birleşimi, evlilik ve kalıcı göçmenlik başvurularında tüm hukuki süreç yönetimini sağlıyoruz. Eş, çocuk ve aile üyelerinin birleşimi için gerekli tüm evrakların hazırlanması ve takibi konusunda uzmanız.',
      features: ['Aile birleşimi başvuruları', 'Evlilik vizesi', 'Hukuki danışmanlık', 'Süreç yönetimi'],
    },
    {
      icon: 'ri-door-open-line',
      title: 'Kapı Vizeleri',
      subtitle: 'Çeşitli Ülkeler',
      description: 'Varış noktasında alınabilen kapı vizeleri için gerekli evrak hazırlığı ve bilgilendirme desteği veriyoruz. Hangi ülkelerde kapı vizesi alınabileceği, gerekli belgeler ve ücretler hakkında detaylı bilgi sağlıyoruz.',
      features: ['Bilgilendirme hizmeti', 'Evrak hazırlığı', 'Ülke bazlı danışmanlık', 'Güncel bilgiler'],
    },
    {
      icon: 'ri-global-line',
      title: 'E-Vizeler',
      subtitle: 'Dubai, Ermenistan, Kuveyt, Suudi Arabistan, Rusya, Vietnam, Küba',
      description: 'Online e-vize başvuru hizmetleri ile hızlı ve kolay vize alma imkanı sunuyoruz. Elektronik vize sistemine sahip ülkeler için başvuru formlarının doldurulması, ödeme işlemleri ve takip hizmetleri veriyoruz.',
      features: ['Online başvuru', 'Hızlı işlem', '7 farklı ülke', 'Dijital teslimat'],
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Özel Danışmanlık',
      subtitle: 'Birebir Destek',
      description: 'İzmir vize danışmanlığı alanında özel durumlarınız için birebir profesyonel danışmanlık hizmeti sunuyoruz. Karmaşık başvurular, red sonrası itiraz süreçleri ve özel durumlar için uzman desteği sağlıyoruz.',
      features: ['Birebir görüşme', 'Özel durum analizi', 'İtiraz süreçleri', 'Kapsamlı destek'],
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-20">
        {/* Hero Section */}
        <section className="relative py-24 bg-gradient-to-br from-navy to-navy-light text-white">
          <div className="container mx-auto px-4 lg:px-8">
            <div className="max-w-4xl mx-auto text-center">
              <h1 className="text-5xl lg:text-6xl font-bold mb-6">
                Hizmetlerimiz
              </h1>
              <p className="text-xl text-gray-200 leading-relaxed">
                <strong>İzmir vize danışmanlığı</strong> alanında geniş hizmet yelpazesi ile yanınızdayız
              </p>
            </div>
          </div>
        </section>

        {/* Services Grid */}
        <section className="py-20 bg-gray-50">
          <div className="container mx-auto px-4 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              {services.map((service, index) => (
                <div
                  key={index}
                  className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all duration-400 hover:-translate-y-1"
                >
                  <div className="flex items-start gap-6">
                    <div className="w-16 h-16 flex items-center justify-center bg-gold/10 rounded-xl flex-shrink-0">
                      <i className={`${service.icon} text-3xl text-gold`}></i>
                    </div>
                    <div className="flex-1">
                      <h3 className="text-2xl font-bold text-navy mb-2">
                        {service.title}
                      </h3>
                      <p className="text-sm text-gold font-semibold mb-4">
                        {service.subtitle}
                      </p>
                      <p className="text-gray-600 text-sm leading-relaxed mb-6">
                        {service.description}
                      </p>
                      <ul className="space-y-2 mb-6">
                        {service.features.map((feature, idx) => (
                          <li key={idx} className="flex items-center gap-2 text-sm text-gray-700">
                            <i className="ri-check-line text-gold"></i>
                            {feature}
                          </li>
                        ))}
                      </ul>
                      <div className="flex items-center justify-end pt-4 border-t border-gray-200">
                        <a
                          href="https://wa.me/905422671171?text=Merhaba%20ben%20lhglobalpass.com%20%C3%BCzerinden%20ileti%C5%9Fime%20ge%C3%A7iyorum"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="bg-gold hover:bg-gold-dark text-navy px-6 py-2 rounded-full text-sm font-semibold transition-all duration-300 whitespace-nowrap"
                        >
                          Bilgi Al
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-white">
          <div className="container mx-auto px-4 lg:px-8">
            <div className="max-w-4xl mx-auto bg-gradient-to-r from-navy to-navy-light text-white p-12 rounded-3xl text-center">
              <h2 className="text-4xl font-bold mb-4">Hangi Hizmeti Seçeceğinizden Emin Değil Misiniz?</h2>
              <p className="text-gray-200 mb-8 text-lg">
                Uzman ekibimiz size en uygun vize türünü belirlemek için ücretsiz danışmanlık hizmeti sunuyor.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a
                  href="https://wa.me/905422671171?text=Merhaba%20ben%20lhglobalpass.com%20%C3%BCzerinden%20ileti%C5%9Fime%20ge%C3%A7iyorum"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-gold hover:bg-gold-dark text-navy px-8 py-4 rounded-full text-base font-semibold transition-all duration-300 hover:shadow-lg inline-flex items-center justify-center gap-2 whitespace-nowrap"
                >
                  <i className="ri-whatsapp-line text-xl"></i>
                  Ücretsiz Danışmanlık
                </a>
                <a
                  href="tel:+905422671171"
                  className="bg-transparent border-2 border-white hover:bg-white text-white hover:text-navy px-8 py-4 rounded-full text-base font-semibold transition-all duration-300 hover:shadow-lg inline-flex items-center justify-center gap-2 whitespace-nowrap"
                >
                  <i className="ri-phone-line text-xl"></i>
                  Hemen Ara
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <WhatsAppButton />
      <CookieBanner />
    </div>
  );
};

export default ServicesPage;
